@let school = school$ | async;

<red-header-content>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button [defaultHref]="defaultHref"></ion-back-button>
    </ion-buttons>
    <ion-title>School Information</ion-title>
  </ion-toolbar>
</red-header-content>
<red-page-content [paddingBottom]="true">
  <ion-list [inset]="true" lines="full" class="no-last-line">
    <ion-list-header> {{school?.SchoolName | titlecase | redDashIfEmpty}} </ion-list-header>
    <ion-item-divider color="primary"> {{school?.isPrivateSchool ? 'Private' : 'Public'}} School </ion-item-divider>
    @if (school?.isPrivateSchool) {
    <ion-item>
      <ion-label color="medium">
        Affiliation<br />
        <ion-note color="dark" class="tw:font-bold tw:text-wrap">
          {{school?.Affiliation | titlecase | redDashIfEmpty}}
        </ion-note>
      </ion-label>
    </ion-item>
    <ion-item>
      <ion-label color="medium">Gender</ion-label>
      <ion-note class="tw:font-bold" color="dark" slot="end">
        {{school?.Gender | titlecase | redDashIfEmpty}}
      </ion-note>
    </ion-item>
    }
    <ion-item lines="none">
      <ion-label color="medium">Distance</ion-label>
      <ion-note class="tw:font-bold" color="dark" slot="end">
        {{school?.Distance | redDashIfEmpty}} miles away
      </ion-note>
    </ion-item>
  </ion-list>

  <ion-list [inset]="true" lines="full" class="no-last-line">
    <ion-list-header> Overview </ion-list-header>
    <ion-item>
      <ion-label color="medium">Highest Grade</ion-label>
      <ion-note class="tw:font-bold" color="dark" slot="end"> {{school?.HighestGrade | redDashIfEmpty}} </ion-note>
    </ion-item>
    <ion-item>
      <ion-label color="medium">Lowest Grade</ion-label>
      <ion-note class="tw:font-bold" color="dark" slot="end"> {{school?.LowestGrade | redDashIfEmpty}} </ion-note>
    </ion-item>
    <ion-item>
      <ion-label color="medium">Student:Teacher Ratio</ion-label>
      <ion-note class="tw:font-bold" color="dark" slot="end">
        {{school?.StudentTeacherRatio | redDashIfEmpty}}
      </ion-note>
    </ion-item>
    <ion-item>
      <ion-label color="medium">Administrators</ion-label>
      <ion-note class="tw:font-bold" color="dark" slot="end"> {{school?.Administrators | redDashIfEmpty}} </ion-note>
    </ion-item>
    <ion-item>
      <ion-label color="medium">Total Enrolled</ion-label>
      <ion-note class="tw:font-bold" color="dark" slot="end"> {{school?.TotalEnrolled | redDashIfEmpty}} </ion-note>
    </ion-item>
  </ion-list>

  <ion-list [inset]="true" lines="full" class="no-last-line">
    <ion-list-header> Contact </ion-list-header>
    <ion-item>
      <ion-label color="medium">
        Address<br />
        <ion-note color="dark" class="tw:font-bold tw:text-wrap"> {{school?.SchoolAddress | redDashIfEmpty}} </ion-note>
      </ion-label>
    </ion-item>
    <ion-item>
      <ion-label color="medium">Phone</ion-label>
      <ion-note class="tw:font-bold" color="dark" slot="end"> {{school?.SchoolPhone | redDashIfEmpty}} </ion-note>
    </ion-item>
    <ion-item>
      <ion-label color="medium">City</ion-label>
      <ion-note class="tw:font-bold" color="dark" slot="end"> {{school?.SchoolCity | redDashIfEmpty}} </ion-note>
    </ion-item>
    <ion-item>
      <ion-label color="medium">State</ion-label>
      <ion-note class="tw:font-bold" color="dark" slot="end"> {{school?.SchoolState | redDashIfEmpty}} </ion-note>
    </ion-item>
    <ion-item>
      <ion-label color="medium">ZIP</ion-label>
      <ion-note class="tw:font-bold" color="dark" slot="end"> {{school?.SchoolZip | redDashIfEmpty}} </ion-note>
    </ion-item>
    <ion-item>
      <ion-label color="medium">ZIP 4</ion-label>
      <ion-note class="tw:font-bold" color="dark" slot="end"> {{school?.SchoolZip4 | redDashIfEmpty}} </ion-note>
    </ion-item>
  </ion-list>
</red-page-content>
